import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/app/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/vendor.css");
;
import(/* webpackMode: "eager" */ "/app/public/styles/fonts.css");
;
import(/* webpackMode: "eager" */ "/app/app/globals.scss");
